import { useCallback } from 'react';
import { EStatKeys, TStats } from './use-fetch-event-overview-stats';

export const useIsLoadingStat = (data: TStats, isPublished: boolean) => {
  return useCallback(
    (statKey: EStatKeys) => {
      if (!isPublished) return false;

      const statCard = data?.[statKey];

      if (!statCard) return true;

      return statCard.loading;
    },
    [data, isPublished]
  );
};
